import { Product } from "features/ProductReel/types";

export interface ProductDetailsState {
  fetchedProduct: Product;
  fetchedProductLoading: boolean;
}

export enum SectionTitleEnum {
  technicalInfo = "technicalInfo",
  functions = "functions",
  description = "description",
  // reviews = "reviews",
}

export interface sectionsConfigType {
  [key: string]: {
    title: string;
    component: JSX.Element;
    showTitle?: boolean;
  };
}
